//顶部tabbar
export const TOP_BAR_HEIGHT = 'TopBarHeight';

// 接口白名单，可以直接略过code校验
export const WHITE_API = new Set(['/login/loginByMobile']);

// 登录token key
export const TOKEN_KEY = 'UserToken';

//捞点好货appid
export const APPID_TAKEOUT = 'gh_94300eb818c2';

//会员小程序id
export const APPID_MERBER = 'gh_490af83aaafb';

//商城小程序id
export const APPID_MALL = 'gh_658ce0087331';
